<template>
  <div class="page">
    <div class="container-general">
      <div class="container">
        
        <Form :show="showForm" />
        
      </div>
    </div>
  </div>
</template>

<script>
import Form from "./components/Form.vue";

// import 'vue-select/dist/vue-select.css';

export default {
  name: "App",
  components: {
    Form,
  },
  data() {
    return {
      showForm: true,
    };
  },
  methods: {
    sendAnalytics(tag) {
      window.click_s_code("o", `home:${tag}`);
    },
  },
};
</script>

<style lang="scss">
@import "./sass/main.scss";

// Mobile
.page {
  background-color: $color-light-default;
  font-family: $font-family-default, sans-serif;
  font-size: $font-size-default-desktop;
  line-height: $line-height-default-desktop;
  color: $color-dark-default;

  .container-general {
    max-width: $bp-limit;

    .container {
      max-width: 100%;
      margin: 0 auto;

      display: flex;
      flex-direction: column;

      align-items: center;
    }
  }
}

@media (max-width: $bp-mobile) {
  .product__section {
    margin-top: 20px;
  }
}

// Desktop
.page {
  @media (min-width: $bp-mobile) {
    .container-general {
      width: 100%;
      margin: 0 auto;
    }
  }
}

</style>
